import { MemberInfoBase as IMemberInfoBase } from "adobe-sign-types";

export class MemberInfoBase implements IMemberInfoBase {
  email: string;

  constructor (data?: Partial<MemberInfoBase>) {
    this.email = data?.email || '';
  }
}